import { Box, Button, Typography } from '@mui/material'
import { useRouteError, useNavigate } from 'react-router-dom'

export default function RouteErrorPage() {
  const error = useRouteError() as { message?: string; status?: number }
  const navigate = useNavigate()

  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      bgcolor: 'background.default',
      p: 3,
    }}>
      <Typography sx={{ fontSize: 48, fontWeight: 700, color: '#14b8a0' }}>
        {error?.status ?? '?'}
      </Typography>
      <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'text.primary' }}>
        Algo deu errado
      </Typography>
      <Typography sx={{ fontSize: 14, color: 'text.secondary', textAlign: 'center', maxWidth: 360 }}>
        {error?.message ?? 'Ocorreu um erro inesperado. Tente recarregar a página.'}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1.5, mt: 1 }}>
        <Button
          variant="outlined"
          onClick={() => window.location.reload()}
          sx={{ borderColor: '#14b8a0', color: '#14b8a0' }}
        >
          Recarregar
        </Button>
        <Button
          variant="contained"
          onClick={() => navigate('/dashboard')}
          sx={{ background: 'linear-gradient(135deg,#14b8a0,#0d9488)', color: '#fff' }}
        >
          Ir para Dashboard
        </Button>
      </Box>
    </Box>
  )
}
